module.exports = __webpack_public_path__ + "static/img/Company-Program_Innovate_bulb.a4b091a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/Company-Program_Innovate_bulb.jpg
// module id = B0j7
// module chunks = 0